import React, { useEffect, useState } from 'react';

import { DevTools } from 'jotai-devtools';
import { useHistory, useLocation } from 'react-router-dom';

import { useDevtoolsShortcut } from '../../utils/hooks/useDevtoolsShortcut';
import { isExternalIFrame } from '../../utils/iframe';

/**
 * URL Debugger component that uses router hooks
 */
const UrlDebugger: React.FC = () => {
  const [currentUrl, setCurrentUrl] = useState('');
  const [debugInfo, setDebugInfo] = useState('');

  useEffect(() => {
    const updateUrl = () => {
      let url = '';
      let info = '';

      url =
        window?.location.pathname +
        window?.location.search +
        window?.location.hash;
      info = 'window.location';

      setCurrentUrl(url);
      setDebugInfo(info);
    };

    // Initial update
    updateUrl();

    // Set up listeners for URL changes
    const handlePopState = () => updateUrl();
    const handleHashChange = () => updateUrl();

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <div className="vai-fixed vai-top-5 vai-right-2.5 vai-bg-black/80 vai-text-white vai-px-3 vai-py-2 vai-rounded vai-font-mono vai-text-xs vai-z-[9999] vai-max-w-sm vai-break-all vai-shadow-lg vai-border vai-border-grey-600 vai-pointer-events-none">
      <div className="vai-font-bold vai-mb-1 vai-text-leaf-500">
        Current URL ({debugInfo}):
      </div>
      <div className="vai-text-white vai-leading-snug">{currentUrl}</div>
    </div>
  );
};

/**
 * Combined debug tools component that can be toggled with RBL keypress
 * Includes both Jotai DevTools and URL debugger
 */
export const DebugTools: React.FC = () => {
  // Get RBL tool state (keyboard shortcut r+b+l)
  const { showDevtools } = useDevtoolsShortcut();

  // Only show when RBL tool is activated via keyboard shortcut
  const shouldShow = showDevtools;
  const shouldShowUrlDebugger = isExternalIFrame() && showDevtools;

  if (!shouldShow) {
    return null;
  }

  return (
    <>
      {/* Jotai DevTools */}
      <DevTools position="top-left" />

      {/* URL Debugger - only show in iframe */}
      {shouldShowUrlDebugger && <UrlDebugger />}
    </>
  );
};

export default DebugTools;
